export enum IntakeType {
  FORM_PROVIDER = 'form-provider-intake',
  SHORT_FORM = 'short-form-intake',
  TYPEFORM = 'typeform-intake',
  NO_INTAKE = 'no-intake',
}

export interface IntakeDetectionResponse {
  clientIntakeType: IntakeType;
  partnerIntakeType?: IntakeType;
}
